// extracted by mini-css-extract-plugin
export default {"adImage":"components-Shared-TakeoverAd-styles__adImage--vZKbk"};